// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';

export const environment = {
  production: false,
  version: env['npm_package_version'] + '-dev',
  serverUrl: '/api',
  defaultLanguage: 'es-ES',
  supportedLanguages: ['es-ES'],
  firebaseConfig: {
    apiKey: 'AIzaSyDXSdQewJf0zmwL-0PxKrDVybU8eTEBKpQ',
    authDomain: 'cmillonario-dev.firebaseapp.com',
    projectId: 'cmillonario-dev',
    storageBucket: 'cmillonario-dev.appspot.com',
    messagingSenderId: '678891069626',
    appId: '1:678891069626:web:807d3a5eb845fffefaa283',
    measurementId: 'G-DK3XLS5JQ2',
  },
  api: {
    deleteAccount: {
      url: 'https://us-central1-cmillonario-dev.cloudfunctions.net/requestDeleteAccounts',
    },
    customers: {
      url: 'https://us-central1-cmillonario-dev.cloudfunctions.net/customers',
    },
    wallet: {
      url: 'https://{{function}}-d5fq3fmulq-uc.a.run.app',
    },
    pronosticos: {
      info: 'https://getgameinfofunction-d5fq3fmulq-uc.a.run.app/getGameInfo',
      purchase: 'https://purchaseigt-d5fq3fmulq-uc.a.run.app/process',
    },
    tradicional: {
      draws: 'https://draws-d5fq3fmulq-uc.a.run.app',
      reservation: 'https://reservation-d5fq3fmulq-uc.a.run.app',
      prizes: 'https://prizes-d5fq3fmulq-uc.a.run.app',
      reconciliation_et: 'https://reconciliationET-d5fq3fmulq-uc.a.run.app',
      purchases: 'https://purchases-d5fq3fmulq-uc.a.run.app',
      reconciliation: 'https://reconciliation-d5fq3fmulq-uc.a.run.app',
      purchase: 'https://purchaseln-d5fq3fmulq-uc.a.run.app',
    },
    nuvei: {
      url: 'https://nuvei-d5fq3fmulq-uc.a.run.app',
    },
    klaviyo: {
      url: 'https://us-central1-cmillonario-dev.cloudfunctions.net/trackEvent',
    },
    timestamp: {
      url: 'https://timestamp-d5fq3fmulq-uc.a.run.app',
    },
    payout: {
      url: 'https://payout-d5fq3fmulq-uc.a.run.app',
    },
    mailSend: {
      url: 'https://sendemail-d5fq3fmulq-uc.a.run.app/send',
      urlVerify: 'https://sendemailcustomer-d5fq3fmulq-uc.a.run.app/verifyEmail',
      urlWithoutAuth: 'https://sendemailwithoutauthcustomer-d5fq3fmulq-uc.a.run.app/sendEmail',
    },
    book: {
      url: 'https://bookuser-d5fq3fmulq-uc.a.run.app',
      paths: {
        login: '/loginPlayer',
      },
    },
  },
  draw: {
    endSales: 60,
  },
  tracking: {
    facebookPixel: { id: '561169853178861', enabled: true },
    googleTagManager: { id: 'GTM-N39KPCFS', enabled: true },
    firebase: { enabled: true },
  },
  notifications: {
    vapidKey: 'BF62u0bfzuSrkMQSQ-qTwquZ9CnkGUp70uOZPhofjrVc6eaYVo6nA09DYl1cIcV39onbqmX0WAEytqYpJVle1HY',
  },
  adminEmails: 'tcaldino@emt.dev',
  casino: {
    cloudApi: {
      url: 'https://casinoframe-d5fq3fmulq-uc.a.run.app',
      getFrame: 'getFrame',
    },
  },
  urlApp: 'https://cmillonario-dev.web.app/',

  userLotenal: {
    ov: 1053,
    user: 'miDia',
    password: 'suerte',
  },
};

// export const environment = {
//   production: true,
//   version: env['npm_package_version'] + '-dev',
//   serverUrl: '/api',
//   defaultLanguage: 'es-ES',
//   supportedLanguages: ['es-ES'],
//   firebaseConfig: {
//     apiKey: 'AIzaSyDmhi9ItAHuauri3FM6YCsbW35NeUlMqqc',
//     authDomain: 'cmillonariomx.firebaseapp.com',
//     projectId: 'cmillonariomx',
//     storageBucket: 'cmillonariomx.firebasestorage.app',
//     messagingSenderId: '348957689338',
//     appId: '1:348957689338:web:77e12c233c49063e1b5043',
//     measurementId: 'G-CCLMPRLGY3',
//   },
//   api: {
//     customers: {
//       url: 'https://us-central1-cmillonariomx.cloudfunctions.net/customers',
//     },
//     wallet: {
//       url: 'https://{{function}}-ykzipn2nea-uc.a.run.app',
//     },
//     pronosticos: {
//       info: 'https://getgameinfofunction-ykzipn2nea-uc.a.run.app/getGameInfo',
//       execute: 'https://executefunction-ykzipn2nea-uc.a.run.app/executeTransaction',
//       purchase: 'https://purchaseigt-ykzipn2nea-uc.a.run.app/process',
//     },
//     tradicional: {
//       draws: 'https://draws-ykzipn2nea-uc.a.run.app',
//       reservation: 'https://reservation-ykzipn2nea-uc.a.run.app',
//       prizes: 'https://prizes-ykzipn2nea-uc.a.run.app',
//       reconciliation_et: 'https://reconciliationET-ykzipn2nea-uc.a.run.app',
//       purchases: 'https://purchases-ykzipn2nea-uc.a.run.app',
//       reconciliation: 'https://reconciliation-ykzipn2nea-uc.a.run.app',
//     },
//     nuvei: {
//       url: 'https://nuvei-ykzipn2nea-uc.a.run.app',
//     },
//     klaviyo: {
//       url: 'https://us-central1-cmillonariomx.cloudfunctions.net/trackEvent',
//     },
//     timestamp: {
//       url: 'https://timestamp-ykzipn2nea-uc.a.run.app',
//     },
//     payout: {
//       url: 'https://payout-ykzipn2nea-uc.a.run.app',
//     },
//   },
//   captcha: {
//     key: '6LcdOHYqAAAAAEQP7R8KI1gucnyKoMBnazyybHha',
//   },
//   draw: {
//     endSales: 60,
//   },
//
//   tracking: {
//     // klaviyo: { publicApiKey: 'pk_bc2ee3cee994011d36c2a79d9577b7d59c', enabled: true },
//     klaviyo: { publicApiKey: 'XnKfHZ', enabled: false },
//     facebookPixel: { id: '561169853178861', enabled: true },
//     googleTagManager: { id: 'GTM-N39KPCFS', enabled: true },
//     firebase: { enabled: true },
//   },
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
